import { Res } from "../types";

const BASEURL = "https://apptest.nbwbw.com";
const URL_PAPERPAGELIST = `${BASEURL}/NewsPaper/read_news_paper_page_list`;
const URL_PAPERCONTENT = `${BASEURL}/NewsPaper/read_news_paper_content`;
// export const request = (data: object) => {};

export const request = (data: object, type: number): Promise<Res> => {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: type === 1 ? URL_PAPERPAGELIST : URL_PAPERCONTENT,
      data: { ...data, version: "3.0" },
      success(res: Res) {
        resolve(res);
      },
      error(err: Error) {
        reject(err);
      }
    });
  });
};
